
import { Box } from '@mui/material'
import { useContext } from 'react';
import { ToolContext } from '../../../../../core/context/ToolContext';
import { SnakeLoader } from '../../../../../core/loader/SnakeLoader';
import { NoDataFound } from '../../../empty/Index';
import { env } from '../../../../../core/Env';
import { rqx } from '../../../../../core/request/API';
import { useHistory } from "react-router-dom/cjs/react-router-dom"
import { Action } from './modal/Action';
import { Lists } from './Lists';

export const SalesPageList = ({ ainfo, listData, listLoader, __init, capgueData }) => {
	const { salespage_state } = useContext(ToolContext)
	const { viewAction, leftBar, } = salespage_state

	const history = useHistory()
	const typeView = (t, dataId) => {
		window.open(`/campaign/sales_page/real_property/view?tab=${t}&id=${dataId.id}`, '_blank')

	}

	const viewHandler = (id, stat) => {
		listData.set({ ...listData.data, current: { value: id, stat } })
	}
	const menuHandler = (id, stat) => {
		listData.set({ ...listData.data, current: { value: id, stat } })
		if (listData.data.current.value !== listData.data.list.id) { viewAction.set({ ...viewAction.data, viewAs: { modal: false } }) }

	}
	const postHandler = (selected) => {
		listData.set({ ...listData.data, action: { selected, modal: true, type: 2, confirmed: false } })
	}
	const disableHandler = (selected) => {
		listData.set({ ...listData.data, action: { selected, modal: true, type: 3, confirmed: false } })
		viewAction.set({ ...viewAction.data, viewAs: { modal: false } })
	}
	const cancelHandler = () => { listData.set({ ...listData.data, action: { selected: null, modal: false, type: 0, confirmed: false } }) }
	const updateHandler = async (dataId) => {
		viewAction.set({ ...viewAction.data, viewAs: { modal: false } })
		history.push(`/campaign/sales_page/real_property/attract/templates/customization/update?id=${dataId.id}&section_id=${dataId.section_id}`)
		menuHandler(0, false)
		leftBar.set(false)
	}
	const proceedHandler = async () => {
		const s = await rqx.post(`<<tool>>/${env()}/realProperty/update_status`, { user_id: window.atob(ainfo.aid).split('_').pop(), ref: 'status', status: listData.data.action.type, id: listData.data.action.selected.id })
		if (s.message === 'success') {
			listData.set({ ...listData.data, action: { selected: null, modal: false, type: 0, confirmed: false } })
			setTimeout(() => {
				__init()
				// eslint-disable-next-line
			}, 800);
		}
	}


	return (
		<Box width="100%" height="100%" flexDirection="column" display="flex" alignItems="center">
			<Box fontSize={12} fontWeight={600} display="flex" alignItems="center" p={1} width="100%" gap={1}>
				<Box width="10%" color="#313131">No.</Box>
				<Box width="15%" color="#313131">Name</Box>
				<Box width="40%" color="#313131">URL</Box>
				<Box width="15%" color="#313131">Date Created</Box>
				<Box width="10%" display="flex" justifyContent="center" color="#313131">Status</Box>
				<Box width="10%" display="flex" justifyContent="center" color="#313131">Action</Box>
			</Box>

			{
				listLoader.data ?
					<Box pt={15} display="flex" justifyContent="center" alignItems="center" flexDirection="column" my={5} >
						<SnakeLoader size="14px" bg="#009F4D" distance="0.3rem" />
					</Box>
					:
					<Box width="100%" className="overflowY" height={570}>
						
							{
								listData.data.list.length > 0 ?
									listData.data.list.map((l, k) => (
										<Lists l={l} k={k} current={listData.data.current}
											menuHandler={menuHandler}
											postHandler={postHandler}
											disableHandler={disableHandler}
											proceedHandler={proceedHandler}
											updateHandler={updateHandler}
											typeView={typeView}
											viewAction={viewAction}
											viewHandler={viewHandler}
											capgueData={capgueData}
										/>

									))
									:
									<Box height={500}><NoDataFound /></Box>
							}
							{/* {
								capgueData.data.length === 0 &&
								<CapGueMsg list={listData.data} />
							} */}
					
					</Box>
			}
			<Action listData={listData} cancelHandler={cancelHandler} proceedHandler={proceedHandler} />
		</Box>
	)
}
